import type { createFetchClient } from '@bank/fetch';

import type { InternalCookieOptions } from './types';
import { getCookie, getExpiresInYears, setCookie } from './utils';

type FetchClient = ReturnType<typeof createFetchClient>;

const COOKIE_NAME = 'stb_id';

/**
 * Reads the existing `stb_id` cookie or generates a new one,
 * registers it with the API, and sets the cookie (2-year expiry, SameSite=Lax).
 */
export const syncStbIdCookie = async (
  client: FetchClient,
  apiRoot: string,
  options: InternalCookieOptions,
): Promise<void> => {
  const existing = getCookie(COOKIE_NAME);
  const stbId = existing ?? crypto.randomUUID().toUpperCase();

  if (!existing) {
    await client.post({
      url: `${apiRoot}/customer/tracking/data`,
      body: { stbId },
    });
  }

  setCookie(COOKIE_NAME, stbId, options, getExpiresInYears(2), ';SameSite=Lax');
};
